<nz-form-control *ngIf="recordProperty !== undefined">
  <nz-time-picker
    [(ngModel)]="recordProperty.ValueAsObject"
    (ngModelChange)="valueChanged()"
    (nzOpenChange)="setMinutesToZero($event)"
    [nzUse12Hours]="this.isTime12hFormat"
    [nzFormat]="this.isTime12hFormat?'h:mm a':'HH:mm'"
    [nzDisabled]="recordProperty.ReadOnly"
    [class]="parentClass">
  </nz-time-picker>
</nz-form-control>
